import React, { useState, useEffect } from 'react';
import Navbar from '../Navbar/Navbar';
import axios from 'axios';
import { useSelector } from 'react-redux';
import {colorDecodeStatus, formatDateSimple, translateStatus} from "../lib/utils";

export default function ArchivePage() {
  const [HistoryData, setHistoryData] = useState([]);
  const [searchTerm, setSearchTerm] = useState('');
  const [sortColumn, setSortColumn] = useState(null);
  const [sortDirection, setSortDirection] = useState('asc');
  const token = useSelector((state) => state.user.token);
  const apiUrl = process.env.REACT_APP_API_URL

  const filteredData = HistoryData.filter((item) => {
    const searchLower = searchTerm.toLowerCase();
    return (
      (item.site && item.site.toLowerCase().includes(searchLower)) ||
      (translateStatus(item.status) && translateStatus(item.status).toLowerCase() === searchLower) ||
      (item.activatedBy?.email && item.activatedBy.email.toLowerCase().includes(searchLower)) ||
      (item.endedBy?.email && item.endedBy.email.toLowerCase().includes(searchLower)) ||
      (item.activatedBy?.authorities?.[0]?.authority && item.activatedBy.authorities[0].authority.toLowerCase().includes(searchLower)) ||
      (formatDateSimple(item.activatedAt) && formatDateSimple(item.activatedAt).includes(searchTerm)) ||
      (formatDateSimple(item.actualActivatedOn) && formatDateSimple(item.actualActivatedOn).includes(searchTerm)) ||
      (formatDateSimple(item.endedAt) && formatDateSimple(item.endedAt).includes(searchTerm)) ||
      (formatDateSimple(item.actualEndedOn) && formatDateSimple(item.actualEndedOn).includes(searchTerm))
    );
  });

  const handleSort = (column) => {
    if (sortColumn === column) {
      setSortDirection(sortDirection === 'asc' ? 'desc' : 'asc');
    } else {
      setSortColumn(column);
      setSortDirection('asc');
    }
  };

  const sortedData = [...filteredData].sort((a, b) => {
    if (!sortColumn) return 0;

    let aValue = '';
    let bValue = '';

    switch (sortColumn) {
      case 'site':
        aValue = a.site || '';
        bValue = b.site || '';
        break;
      case 'status':
        aValue = translateStatus(a.status) || '';
        bValue = translateStatus(b.status) || '';
        break;
      case 'activatedAt':
        aValue = new Date(a.activatedAt || 0).getTime();
        bValue = new Date(b.activatedAt || 0).getTime();
        break;
      case 'actualActivatedOn':
        aValue = new Date(a.actualActivatedOn || 0).getTime();
        bValue = new Date(b.actualActivatedOn || 0).getTime();
        break;
      case 'activatedBy':
        aValue = a.activatedBy?.email || '';
        bValue = b.activatedBy?.email || '';
        break;
      case 'role':
        aValue = a.activatedBy?.authorities?.[0]?.authority || '';
        bValue = b.activatedBy?.authorities?.[0]?.authority || '';
        break;
      case 'endedAt':
        aValue = new Date(a.endedAt || 0).getTime();
        bValue = new Date(b.endedAt || 0).getTime();
        break;
      case 'actualEndedOn':
        aValue = new Date(a.actualEndedOn || 0).getTime();
        bValue = new Date(b.actualEndedOn || 0).getTime();
        break;
      case 'endedBy':
        aValue = a.endedBy?.email || '';
        bValue = b.endedBy?.email || '';
        break;
      default:
        return 0;
    }

    if (typeof aValue === 'string') {
      aValue = aValue.toLowerCase();
      bValue = bValue.toLowerCase();
      return sortDirection === 'asc' ? aValue.localeCompare(bValue) : bValue.localeCompare(aValue);
    } else {
      return sortDirection === 'asc' ? aValue - bValue : bValue - aValue;
    }
  });


  useEffect(() => {
    if (token) {
      fetchData();
    }
  }, [token]);


    const fetchData = async () => {
    try {
      const response = await axios.get(
        `${apiUrl}/histo/all`,
        {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
      setHistoryData(response.data);
      console.log(response.data)
    
    } catch (error) {
      console.error('Error fetching data:', error);
    }
  };

  return (
    <>
      <Navbar />
      <div className="container mx-auto p-2 w-full">
        <h3 className='text-lg font-bold mb-3 text-trust-blue'>
          Archives des situations de crise
        </h3>

        {/* Search Bar */}
        <div className="mb-2">
          <div className="relative">
            <input
              type="text"
              placeholder="🔍 Rechercher dans les archives (site, statut, email, date...)"
              value={searchTerm}
              onChange={(e) => setSearchTerm(e.target.value)}
              className="w-full px-4 py-3 border-2 border-gray-300 rounded-lg focus:outline-none focus:border-trust-blue transition-colors text-sm"
            />
            {searchTerm && (
              <button
                onClick={() => setSearchTerm('')}
                className="absolute right-3 top-1/2 transform -translate-y-1/2 text-gray-500 hover:text-gray-700 text-xl"
              >
                ✕
              </button>
            )}
          </div>
          {searchTerm && (
            <p className="text-xs text-gray-500 mt-2">
              {filteredData.length} résultat{filteredData.length !== 1 ? 's' : ''} trouvé{filteredData.length !== 1 ? 's' : ''}
            </p>
          )}
        </div>
      </div>

      <div className="px-16">
        <div className="shadow-lg rounded-lg mx-auto overflow-hidden">
          <div className="overflow-y-auto max-h-[680px]">
            <table className="min-w-max w-full table-auto">
              <thead className='sticky top-0 z-10'>
                <tr className="bg-gradient-to-r from-trust-blue to-blue-600 text-white text-sm leading-normal font-semibold">
                  <th className="py-4 px-3 text-left cursor-pointer hover:bg-blue-700 transition-colors" onClick={() => handleSort('site')}>
                    <div className="flex items-center gap-1">
                      Site affecté
                      {sortColumn === 'site' && <span>{sortDirection === 'asc' ? '↑' : '↓'}</span>}
                    </div>
                  </th>
                  <th className="py-4 px-3 text-left cursor-pointer hover:bg-blue-700 transition-colors" onClick={() => handleSort('status')}>
                    <div className="flex items-center gap-1">
                      Statut
                      {sortColumn === 'status' && <span>{sortDirection === 'asc' ? '↑' : '↓'}</span>}
                    </div>
                  </th>
                  <th className="py-4 px-3 text-left cursor-pointer hover:bg-blue-700 transition-colors" onClick={() => handleSort('activatedAt')}>
                    <div className="flex items-center gap-1">
                      <div>Début de<br />la crise</div>
                      {sortColumn === 'activatedAt' && <span>{sortDirection === 'asc' ? '↑' : '↓'}</span>}
                    </div>
                  </th>
                  <th className="py-4 px-3 text-left cursor-pointer hover:bg-blue-700 transition-colors" onClick={() => handleSort('actualActivatedOn')}>
                    <div className="flex items-center gap-1">
                      <div>Activation de<br />la crise</div>
                      {sortColumn === 'actualActivatedOn' && <span>{sortDirection === 'asc' ? '↑' : '↓'}</span>}
                    </div>
                  </th>
                  <th className="py-4 px-3 text-left cursor-pointer hover:bg-blue-700 transition-colors" onClick={() => handleSort('activatedBy')}>
                    <div className="flex items-center gap-1">
                      Activé par
                      {sortColumn === 'activatedBy' && <span>{sortDirection === 'asc' ? '↑' : '↓'}</span>}
                    </div>
                  </th>
                  <th className="py-4 px-3 text-left cursor-pointer hover:bg-blue-700 transition-colors" onClick={() => handleSort('role')}>
                    <div className="flex items-center gap-1">
                      Rôle
                      {sortColumn === 'role' && <span>{sortDirection === 'asc' ? '↑' : '↓'}</span>}
                    </div>
                  </th>
                  <th className="py-4 px-3 text-left cursor-pointer hover:bg-blue-700 transition-colors" onClick={() => handleSort('endedAt')}>
                    <div className="flex items-center gap-1">
                      <div>Fin de<br />la crise</div>
                      {sortColumn === 'endedAt' && <span>{sortDirection === 'asc' ? '↑' : '↓'}</span>}
                    </div>
                  </th>
                  <th className="py-4 px-3 text-left cursor-pointer hover:bg-blue-700 transition-colors" onClick={() => handleSort('actualEndedOn')}>
                    <div className="flex items-center gap-1">
                      <div>Désactivation<br />de la crise</div>
                      {sortColumn === 'actualEndedOn' && <span>{sortDirection === 'asc' ? '↑' : '↓'}</span>}
                    </div>
                  </th>
                  <th className="py-4 px-3 text-left cursor-pointer hover:bg-blue-700 transition-colors" onClick={() => handleSort('endedBy')}>
                    <div className="flex items-center gap-1">
                      Terminé par
                      {sortColumn === 'endedBy' && <span>{sortDirection === 'asc' ? '↑' : '↓'}</span>}
                    </div>
                  </th>
                </tr>
              </thead>
              <tbody className="text-gray-700 text-sm font-normal bg-white">
                  {sortedData.length > 0 ? (
                    sortedData.map((Histo, index) => (
                    <tr key={index} className="border-b border-gray-200 hover:bg-blue-50 transition-colors">
                      <td className="py-2 px-3 whitespace-nowrap max-w-xs truncate overflow-hidden text-ellipsis" title={Histo.site || "-"}>
                        <span className="font-medium text-gray-800">{Histo.site || "-"}</span>
                      </td>
                      <td className="py-2 px-3 whitespace-nowrap" style={{ color: colorDecodeStatus(Histo.status) }}>
                        <span className="px-3 py-1 rounded-full text-xs font-semibold" style={{ backgroundColor: colorDecodeStatus(Histo.status) + '20' }}>
                          {translateStatus(Histo.status)}
                        </span>
                      </td>                  
                      <td className="py-2 px-3 whitespace-nowrap text-xs" title={formatDateSimple(Histo.activatedAt) || "-"}>
                        {formatDateSimple(Histo.activatedAt) || "-"}
                      </td>
                      <td className="py-2 px-3 whitespace-nowrap text-xs" title={formatDateSimple(Histo.actualActivatedOn) || "-"}>
                        {formatDateSimple(Histo.actualActivatedOn) || "-"}
                      </td>
                      <td className="py-2 px-3 whitespace-nowrap max-w-xs truncate overflow-hidden text-ellipsis" title={Histo.activatedBy?.email || "-"}>
                        {Histo.activatedBy?.email || "-"}
                      </td>
                      <td className="py-2 px-3 whitespace-nowrap max-w-xs truncate overflow-hidden text-ellipsis" title={Histo.activatedBy?.authorities?.[0]?.authority || "-"}>
                        {Histo.activatedBy && Histo.activatedBy.authorities && Histo.activatedBy.authorities.length > 0 ? Histo.activatedBy.authorities[0].authority: '-'}
                      </td>                
                      <td className="py-2 px-3 whitespace-nowrap text-xs" title={formatDateSimple(Histo.endedAt) || "-"}>
                        {formatDateSimple(Histo.endedAt)|| "-"}
                      </td>
                      <td className="py-2 px-3 whitespace-nowrap text-xs" title={formatDateSimple(Histo.actualEndedOn) || "-"}>
                        {formatDateSimple(Histo.actualEndedOn)|| "-"}
                      </td>
                      <td className="py-2 px-3 whitespace-nowrap max-w-xs truncate overflow-hidden text-ellipsis" title={Histo.endedBy?.email || "-"}>
                        {Histo.endedBy?.email || "-"}
                      </td>
                    </tr>
                  ))
                ) : (
                  <tr>
                    <td colSpan="9" className="py-8 px-6 text-center text-gray-500">
                      {searchTerm ? "Aucun résultat ne correspond à votre recherche" : "Aucune donnée disponible"}
                    </td>
                  </tr>
                )}
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </>
  );
}
